module.exports = __webpack_public_path__ + "img/header3.0fb94ae7.png";